// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"aad197d9","787":"545aecf5"}[chunkId] + ".chunk.js";
};